import { LocationSelect as LibLocationSelect } from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { usePersistedGeolocation } from '@modules/geolocation/geolocation.store';

export const LocationSelect = () => {
  const { value } = usePersistedGeolocation();

  return (
    <LinkWrapper href="/location/edit">
      <LibLocationSelect
        label="Exibindo benefícios próximos a:"
        selectedLocation={value?.address}
      />
    </LinkWrapper>
  );
};
